import type { DrawerItem } from '@/components/subject/configs.ts';

const experiments: DrawerItem[] = [
  // {
  //   title: '3.三角函数图像',
  //   icon: 'lucide:folder',
  //   children: [
  //     { title: '波浪线', icon: 'lucide:flask-conical', route: `/experiment/tilde` },
  //     { title: '摩天轮形成三角函数图像', icon: 'lucide:flask-conical', route: `/experiment/ferris-wheel` },
  //     { title: '弹簧振子形成三角函数图像', icon: 'lucide:flask-conical', route: `/experiment/spring-oscillator` },
  //     { title: '单摆形成三角函数图像', icon: 'lucide:flask-conical', route: `/experiment/simple-pendulum` },
  //     { title: '三角函数叠加', icon: 'lucide:flask-conical', route: `/experiment/trig-overlay` },
  //   ],
  // },
];

const experimentConfig = {
  experiments,
};

export { experimentConfig };
